import React, { useRef, useState , useEffect } from "react";
import {Navbar, Button } from 'flowbite-react';
import { HiArrowLeft } from "react-icons/hi2";
import commercialInsuranceImg from "../../../img/commercial-insurance.svg";
import { useSearchParams, useNavigate } from "react-router-dom";
import { handleLoadCommenrcialInsurance } from "./handler"
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { FaCamera } from "react-icons/fa";
import { updateMemberRequirement, handleImageUpload } from "../../handler";
import moment from "moment";
import axios from "axios";
import { ONBOARDING_API_ENDPOINT } from "../../../config/url.config";
import { getAuthHeader } from "../../../utils/superFetch";

const CommercialInsuranceComponent = (props) => {
    const cssForImageCard = {
        success: {
          imageDiv:
            "mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10",
        },
        standard: {
          imageDiv:
            "mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10",
        },
      };
    
    const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
      
    const navigate = useNavigate();
    let [commercialInsurance, setCommercialInsurance] = useState();
    let [submitButton, setSubmitButton] = useState();
    let [insuranceDetails, setInsuranceDetails] = useState({
        insuranceCompany: "",
        insuranceExpiryDate: "",
    });
    let [validation, setValidation] = useState(false);
    let [validationOnSubmit, setValidationOnSubmit] = useState({
        show: false,
        message: "",
        class: "",
    });
    let [userUploadedInsurancePic, setUserUploadedInsurancePic] = useState(false);
    let [insuranceLoading, setInsuranceLoading] = useState(false);
    
    const insuranceLogRef = useRef(null);

    useEffect(() => {
        handleLoadCommenrcialInsurance(props.memberRequirement, props.memberRequirement.requiredDocuments, props.itemIndex, setInsuranceDetails, setCommercialInsurance,setUserUploadedInsurancePic, commercialInsuranceImg)
    }, [])

    const handleFileChange = async (e, itemName) => {
        let file = e.target.files[0];
        if (
          !["image/png", "image/jpeg", "image/jpg"].includes(file.type) ||
          file.size / 1000000 > 7
        ) {
          setValidation(true);
          return;
        }
        setInsuranceLoading(true);
        await handleImageUpload(file, "carInsurance",itemName,setCommercialInsurance,setValidation,setUserUploadedInsurancePic,setSubmitButton,props.memberRequirement, props.setMemberRequirement,props.itemIndex, navigate,selectedProfileType.profileId)
          setValidation(true);
          setInsuranceLoading(false);
        
      };
    
      const validateOnChange = () => {
        if (validationOnSubmit.show && insuranceDetails.insuranceCompany === "") {
          setValidationOnSubmit({
            show: true,
            message: "Provide valid name of the insurance company",
            class: "error-msg",
          });
          return;
        } else if (
          validationOnSubmit.show &&
          (insuranceDetails.insuranceExpiryDate === "" ||
            moment(insuranceDetails.insuranceExpiryDate, "YYYY-MM-DD").diff(
              moment(),
              "years"
            ) < 1)
        ) {
          setValidationOnSubmit({
            show: true,
            message: "Provide valid insurance expiry date",
            class: "error-msg",
          });
          return;
        } else if (validationOnSubmit.show && !userUploadedInsurancePic) {
          setValidationOnSubmit({
            show: true,
            message: "Missing image of you're motorcycle insurance",
            class: "error-msg",
          });
          return;
        } else {
          setValidationOnSubmit({ show: false, message: "", class: "" });
          return;
        }
      };

      const handleSaveInformation = async () => {
        if (insuranceDetails.insuranceCompany === "") {
          setValidationOnSubmit({
            show: true,
            message: "Provide valid name of the insurance company",
            class: "error-msg",
          });
          return;
        }
        if (
          insuranceDetails.insuranceExpiryDate === "" ||
          moment(insuranceDetails.insuranceExpiryDate, "YYYY-MM-DD").diff(
            moment(),
            "days"
          ) < 1
        ) {
          setValidationOnSubmit({
            show: true,
            message: "Provide valid insurance expiry date",
            class: "error-msg",
          });
          return;
        }
        if (!userUploadedInsurancePic) {
          setValidationOnSubmit({
            show: true,
            message: "Missing image of you're motorcycle insurance",
            class: "error-msg",
          });
          return;
        }
    
        let body = {
          item: "commercialInsurance",
          requiredItems: [
            {
              itemName: "insuranceCompany",
              value: insuranceDetails.insuranceCompany,
            },
            {
              itemName: "insuranceExpiryDate",
              value: insuranceDetails.insuranceExpiryDate,
            },
          ],
        };
        const config = {
          headers: {
            "content-type": "application/json",
            "upload-document": false,
            ...getAuthHeader(),
          },
        };
    
        try {
          const res = await axios.post(
            `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${selectedProfileType.profileId}`,
            body,
            config
          );
          if (res.status) {
            let tmpMemberData = { ...props.memberRequirement };
    
            for (
              let i = 0;
              i <
              tmpMemberData.requiredDocuments[props.itemIndex].requiredItems.length;
              i++
            ) {
              if (
                tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i]
                  .itemName in insuranceDetails
              ) {
                updateMemberRequirement(
                  props.memberRequirement,
                  props.setMemberRequirement,
                  props.itemIndex,
                  tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i]
                    .itemName,
                  insuranceDetails[
                    `${
                      tmpMemberData.requiredDocuments[props.itemIndex]
                        .requiredItems[i].itemName
                    }`
                  ]
                );
              }
            }
            props.setOpenUploadDocument({ openDocument: false, documentType: "" });
          }
        } catch (error) {
          console.log("Error message", error.message);
        }
      };

    return (
        <>
            <Navbar
                fluid={true}
                rounded={true}
                className='shadow mb-3' style={{position:'fixed', width:'100%', top:'0'}}
            >  
                <Navbar.Brand onClick={()=>{props.setOpenUploadDocument({openDocument : false , documentType : ""})}}>
                  <HiArrowLeft className='h-10 w-5 ml-2' />
                </Navbar.Brand>
            </Navbar>
            <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
                <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">Commercial Insurance</h5>

        {validationOnSubmit.show && (
          <div className={validationOnSubmit.class}>
            <span>{validationOnSubmit.message}</span>
          </div>
        )}

{userUploadedInsurancePic && (
          <div
            class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"
            style={{ paddingRight: "10px" }}
          >
            <MdCheckCircle style={{ color: "#15BE44" }} />
          </div>
        )}
                <label className='font-bold tracking-tight text-gray-900'>Details</label>
                <div className={
            userUploadedInsurancePic
              ? cssForImageCard.success.imageDiv
              : cssForImageCard.standard.imageDiv
          }>
            {/* {validation && (
            <div className="error-msg">
              <span>
                Invalid image. Only images of type png, jpg, jpeg with size
                below 7mb can be uploaded
              </span>
            </div>
          )} */}
                    <img src={commercialInsurance}
                         className="w-auto m-auto"
                         alt="Ryde" />
                    <p className='text-xs text-gray-400 tracking-tight mt-2'><i><sup>.</sup>License plate number of commercial <br/>insurance must match that of your vehicle log <br/>
                    <sup>.</sup>Policy T&C must be legible.<br/>
                    <sup>.</sup>We will not accept if your insurance states does not cover use for hire and reward<br/>
                    

                     </i></p>
                    <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={() => {
    insuranceLogRef.current.click();
  }}>  {/* Loading option when image is uploading , onclick function */}
                    {insuranceLoading ? (
              <BsThreeDots className="h-5 w-10" />
            ) : (
              <FaCamera className="h-5 w-10" />
            )}
            <label // for="file-upload"
              class="relative cursor-pointer rounded-md font-medium"
            >
              <span>
                {insuranceLoading
                  ? "Saving"
                  : userUploadedInsurancePic
                  ? "Replace"
                  : "Upload"}
              </span>
            </label>
                    </Button>
                    <input 
                        id="file-upload" 
                        name="file-upload"
                        type="file"
                        ref={insuranceLogRef}
                        style={{display: 'none', width:'0px'}}
                        onChange={(event) => {
                            handleFileChange(event, "commercialInsurance");
                            validateOnChange();
                          }}
                    />
                </div>

                <div className="col-span-6 mb-8">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                        Insurance Company
                    </label>
                    <input
                        type="text"
                        name="contact-number"
                        placeholder=''
                        id=""
                        autoComplete=""
                        value={insuranceDetails.insuranceCompany}
                  onChange={(e) => {
                    setInsuranceDetails({
                      ...insuranceDetails,
                      insuranceCompany: e.target.value,
                    });
                    validateOnChange();
                  }}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        // onChange={(e) => {setVehicalDetails({...vehicalDetails, vehicleNumber: e.target.value})}}
                        // onChange={(e) => { setVehicalDetails(vehicalDetails=> ({...vehicalDetails, vehicleNumber: e.target.value})); updateButtonState() ; validateOnChange();}  }
                     />
                </div>

                <div className="col-span-6">
                    <label
                        htmlFor="name"
                        className="block text-sm font-medium text-gray-700"
                    >
                        Insurance Expiry Date
                    </label>
                    <input
                        type="date"
                        name="name"
                        id="name"
                        autoComplete="name"
                        value={insuranceDetails.insuranceExpiryDate}
                        onChange={(e) => {
                          setInsuranceDetails({
                            ...insuranceDetails,
                            insuranceExpiryDate: e.target.value,
                          });
                          validateOnChange();
                        }}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                    <span className="block text-sm font-medium text-gray-700">
                    <i>
                    * Please ensure your insurance expiry has a 1 year validity
                    period.
                    </i>
                    </span>
                </div>

                <Button className='bg-primary w-full mt-5' pill={true} disabled={false} 
                onClick={handleSaveInformation}
                        // onClick={()=>{
                        // if(userUploadedLogPic ) {
                        //     props.setOpenUploadDocument({
                        //       openDocument: false,
                        //       documentType: "",
                        //     });
                        //   } else {
                        //     setValidationOnSubmit(true)
                        //     window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                        //   }
                        // }}
                >
                    Save
                  </Button>





            </div>
        </>
    )
}

export default CommercialInsuranceComponent;